<div class="grid grid-cols-2 gap-4">
  <ng-container *ngFor="let field of fields" [ngSwitch]="field.dataType">

    <!-- STRING -->
    <mat-form-field *ngSwitchCase="'string'" appearance="fill" class="col-span-1">
      <mat-label>{{ field.labels?.master }}</mat-label>
      <input matInput [(ngModel)]="model[field.name]" [name]="field.name" [required]="field.required"
             [placeholder]="field.labels?.master" />
    </mat-form-field>

    <!-- NUMBER -->
    <mat-form-field *ngSwitchCase="'number'" appearance="fill" class="col-span-1">
      <mat-label>{{ field.labels?.master }}</mat-label>
      <input matInput type="number" [(ngModel)]="model[field.name]" [name]="field.name" [required]="field.required"
             [placeholder]="field.labels?.master" />
    </mat-form-field>

    <!-- DATE -->
    <mat-form-field *ngSwitchCase="'date'" appearance="fill" class="col-span-1">
      <mat-label>{{ field.labels?.master }}</mat-label>
      <input matInput [matDatepicker]="picker" [(ngModel)]="model[field.name]" [name]="field.name"
             [required]="field.required" />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    <!-- BOOLEAN -->
    <app-toggle-option *ngSwitchCase="'boolean'" [title]="field.labels?.master" [(ngModel)]="model[field.name]"
                       [name]="field.name" class="col-span-1">
    </app-toggle-option>

  </ng-container>
</div>
